import { callApi } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";
import { buildIssueShareLink } from "./issueShare";

interface SendIssueTelegramParams {
  userInfo: any;
  formData?: any;
  data?: any;
  msgFlag: "new" | "reply";
  snapshotData?: any;
  cdMenu?: string;
}

export const sendIssueSnapshotTelegram = async ({
  userInfo,
  formData,
  data,
  msgFlag,
  snapshotData,
  cdMenu = "SN_SFA_ISSUE_REG_002",
}: SendIssueTelegramParams) => {
  const mergedForm = formData || {};
  const mergedData = data || {};
  const requestSnapshotData = snapshotData || {
    ...mergedForm,
    ...mergedData,
  };
  // 2026-03-30: FE에서 share_url을 우선 확정해서 전달한다.
  // BE는 이 값을 기준으로 공용방/개인방 링크 정책(개인방 sso_token 추가)을 분기한다.
  const shareUrl =
    mergedData?.share_url ||
    mergedForm?.share_url ||
    (await buildIssueShareLink({
      no_issue: mergedData?.no_issue || mergedForm?.no_issue,
      st_issue: mergedData?.st_issue || mergedForm?.st_issue,
      dc_title: mergedData?.dc_title || mergedForm?.dc_title,
    })) ||
    "";

  const params = {
    ...mergedForm,
    ...mergedData,
    cd_firm: userInfo?.cd_firm,
    cd_menu: cdMenu,
    no_issue: mergedData?.no_issue || mergedForm?.no_issue,
    msg_flag: msgFlag,
    share_url: shareUrl,
    origin: `${window.location.origin}/snotes`,
    send_telegram: true,
    snapshot_data: requestSnapshotData,
  };

  const result: any = await callApi("telegram/sendIssueSnapshotMsg", params);
  if (!result?.status) {
    await showDialog(
      "alter",
      result?.data?.message ||
        result?.message ||
        "Issue snapshot request failed."
    );
  }
  return result;
};

export const sendIssueSnapshotTelegramByParams = async (params: any) => {
  const hasSnapshotData =
    Object.prototype.hasOwnProperty.call(params || {}, "snapshot_data") ||
    Object.prototype.hasOwnProperty.call(params || {}, "snapshotData");

  const resolvedNoIssue = (
    params?.no_issue ??
    params?.snapshot_data?.no_issue ??
    params?.snapshotData?.no_issue ??
    ""
  )
    .toString()
    .trim();
  // 2026-03-30: 호출부에서 share_url 누락 시 여기서 최종 보정한다.
  const shareUrl =
    params?.share_url ||
    params?.link ||
    params?.dc_link ||
    (await buildIssueShareLink({
      no_issue: resolvedNoIssue,
      st_issue: params?.st_issue,
      dc_title: params?.dc_title,
    })) ||
    "";

  const requestParams = {
    ...params,
    cd_menu: params?.cd_menu || "SN_SFA_ISSUE_REG_002",
    no_issue: resolvedNoIssue,
    share_url: shareUrl,
    origin: params?.origin || `${window.location.origin}/snotes`,
    send_telegram:
      typeof params?.send_telegram === "boolean" ? params.send_telegram : true,
    ...(hasSnapshotData
      ? { snapshot_data: params?.snapshot_data || params?.snapshotData }
      : {}),
  };

  const result: any = await callApi(
    "telegram/sendIssueSnapshotMsg",
    requestParams
  );
  if (!result?.status) {
    await showDialog(
      "alter",
      result?.data?.message ||
        result?.message ||
        "Issue snapshot request failed."
    );
  }
  return result;
};
